import * as React from "react";
import classnames from "classnames";
import { LocationSearch } from "@grandvisionhq/locations";
import { useFeatureToggles } from "@grandvisionhq/state";
import useStoreSearchFilters from "../../../../hooks/hooks/use-store-search-filters.js";
import { useTabs } from "../../../../hooks/hooks/use-tabs.js";
import NoStoresAlertContainer from "../../../NoStoresAlert/components/NoStoresAlert/NoStoresAlertContainer.js";
import StoreFinderItemContainer from "../../../StoreFinderItem/components/StoreFinderItem/StoreFinderItemContainer.js";
import StoreFinderMapContainer from "../../../StoreFinderMap/components/StoreFinderMap/StoreFinderMapContainer.js";
import { StoreListTopContentFallback } from "../../../StoreListTopContentFallback/components/StoreListTopContentFallback/StoreListTopContentFallback.js";
import StoreSearchFormContainer$1 from "../../../StoreSearchForm/components/StoreSearchForm/StoreSearchFormContainer.js";
import StoreSearchFormContainer from "../../../StoreSearchForm/components/StoreSearchForm/StoreSearchFormContainerV2.js";
/* empty css                          */
import { useStoreFinderContext } from "../../../../context/StoreFinder/context/StoreFinder/context.js";
import { useStoreFinderSlots } from "../../../../context/StoreFinderSlots/context/StoreFinderSlots/context.js";
const StoreFinderContainer = ({
  isInsideModal,
  listTopContent,
  listInfoContent,
  listItemComponent,
  infoWindowContentComponent,
  buttonsComponent,
  storeSearchFilters: propStoreSearchFilters,
  highlightPreferredStore,
  className,
  showAttributesAsTags
}) => {
  const { isStoreFiltersStoresEnabled } = useFeatureToggles();
  const { isPristineSearch, isStoresLoading, stores, config, setHoveredStore } = useStoreFinderContext();
  const showTabs = useTabs();
  const { Slots } = useStoreFinderSlots();
  const [{ applyActiveFilters }, { hasActiveFilters, loading }] = useStoreSearchFilters({
    filters: propStoreSearchFilters
  });
  const { googleMapsId } = config;
  const showListTopContent = Boolean(listTopContent);
  const showListInfoContent = Boolean(listInfoContent);
  const showNoStoresAlert = !isPristineSearch && !isStoresLoading && stores.length === 0;
  const ButtonsComponent = buttonsComponent;
  const StoreSearchFormComponent = isStoreFiltersStoresEnabled ? StoreSearchFormContainer : StoreSearchFormContainer$1;
  const onMouseEnterHandler = React.useCallback(
    (store) => setHoveredStore(store),
    [setHoveredStore]
  );
  const onMouseLeaveHandler = React.useCallback(() => setHoveredStore(null), [setHoveredStore]);
  const ListItemComponent = listItemComponent ?? StoreFinderItemContainer;
  const filteredStores = React.useMemo(
    () => applyActiveFilters(stores),
    [stores, applyActiveFilters]
  );
  const storeListInfoContent = /* @__PURE__ */ React.createElement(React.Fragment, null, showNoStoresAlert ? /* @__PURE__ */ React.createElement("div", { className: "store-finder-stores-v2__info-content" }, /* @__PURE__ */ React.createElement(NoStoresAlertContainer, null)) : null, showListInfoContent ? listInfoContent : null);
  return /* @__PURE__ */ React.createElement(
    LocationSearch,
    {
      className: classnames("store-finder-stores-v2", className, {
        "store-finder-stores-v2--modal": isInsideModal
      }),
      googleMapsId,
      showTabs,
      searchForm: /* @__PURE__ */ React.createElement(StoreSearchFormComponent, null),
      listTopContent: /* @__PURE__ */ React.createElement(React.Fragment, null, Slots?.SideComponents ? /* @__PURE__ */ React.createElement(Slots.SideComponents, null) : null, showListTopContent ? listTopContent : /* @__PURE__ */ React.createElement(StoreListTopContentFallback, null)),
      listInfoContent: storeListInfoContent,
      loadingListItems: isStoresLoading,
      listItems: stores.length ? filteredStores.map((store) => /* @__PURE__ */ React.createElement(
        ListItemComponent,
        {
          loading,
          key: store.globalStoreId,
          store,
          buttons: ButtonsComponent ? /* @__PURE__ */ React.createElement(ButtonsComponent, { store, view: "list" }) : void 0,
          onMouseEnter: onMouseEnterHandler,
          onMouseLeave: onMouseLeaveHandler,
          showAttributesAsTags
        }
      )) : [],
      mapContent: /* @__PURE__ */ React.createElement(
        StoreFinderMapContainer,
        {
          stores: filteredStores,
          infoWindowContentComponent,
          buttonsComponent: ButtonsComponent,
          showAttributesAsTags
        }
      ),
      highlightPreferredStore
    }
  );
};
export {
  StoreFinderContainer as default
};
//# sourceMappingURL=StoreFinderContainer.js.map
